export const PROFILE_CONSTANT = {
  SEE_POST: 'See Post',
  SCHEDULE_TAG: 'SCHEDULE',
  COLLAB_SCHEDULE_TAG: 'COLLAB#SCHEDULE#',
  LAST_LOGIN_EMAIL: 'lastLoginEmail',
  SEE_IMAGE: 'See Image',
  SEE_COURSE: 'See Course',
  SEE_DOWNLOADABLE: 'View Downloadable',
  WATCH_THE_VIDEO: 'Watch the Video',
  lISTEN_THE_AUDIO: 'Listen to the Audio',
  GIVE_AWAY: 'Giveaway',
  READ_ARTICLE: 'Read Article',
  SEE_TYPE: 'See [type]',
  DOWNLOADABLE: 'Downloadable',
  WATCH_THE_REEL: 'Watch the Reel',
  WATCH_THE_POLL: 'View the Poll',
  VIEW_DOWNLOADABLES: 'View Downloadable',
  VIEW_GIVEAWAY: 'View Giveaway',
  OPEN_URL: 'Open URL',
  READ_TEXT: 'Read Text',
  SEE_CONTENT: 'See Content',
  WELCOME_VIDEO: 'welcome_video',
  FUNDRAISER: 'Fundraiser',
  NO_POSTS_FILTERED: 'hasn\'t made any posts that match your filter criteria.',
  NO_POSTS_NO_FILTER: 'hasn\'t made any posts yet.',
  DETAILS: 'Details',
  BADGE_DETAIL: 'Badge Detail',
  AVAILABLE_POINTS: 'Available Points',
  VIEW_DETAILS: 'View Details'
};

export const BADGE_MESSAGES = {
  AUTO_ASSIGN_LOYALTY: (threshold: number) =>
    `Awarded for earning ${threshold} Loyalty Points in Past 30 Days`
} as const;

export const POST_TYPE_FILTER_LABELS = {
  ALL_TYPES: 'All Content',
  ALL_TYPES_VALUE: 'All',
  VIDEOS: 'Videos',
  IMAGES: 'Images',
  ARTICLES: 'Articles',
  AUDIO: 'Audio',
  REELS: 'Reels',
  POLLS: 'Polls',
  LINKS: 'Links',
  TEXT: 'Text',
  FUNDRAISERS: 'Fundraisers'
};

export const MESSAGE = {
  ACCOUNT_SUSPENDED: 'Account Suspended',
  ACCOUNT_PAUSED: 'Account Paused',
  THIS_USERS_ACCOUNT_IS_PRIVATE: "This Creator's Account is Private",
  THIS_USER_REQUESTS_THEIR_ACCOUNT_TO_FOLLOW:
    'This Creator Requests their Account be Followed',
  REQUEST_FOLLOW_TO_VIEW_THEIR_CONTENT:
    'Request to Follow to view their content and access other features.',
  FOLLOW_TO_VIEW_THEIR_CONTENT:
    'Follow to view their content and access other features.',
  SUSPENSION_REASON: 'TopFan suspends accounts which violate the ',
  TERMS_OF_SERVICE: 'Terms of Service',
  PAUSED_REASON: 'Account is currently paused by the user',
  INFO_ICON_MESSAGE:
    "You can receive an award from a creator by being their weekly “Fan of the Week”, “Most Engaged” or “Top Recruiter”. For details, visit a creator's leaderboards section to see where you stand each week. Good luck!",
  USER_SITE: "'s Site",
  PROFILE_SITE: "'s Profile",
  MY_SITE: 'My Site',
  MY_PROFILE: 'My Profile',
  LIFETIME_LOYALTY_POINTS: 'Lifetime Loyalty Points',
  Merchandise: 'Merchandise',
  Experience: 'Experience'
};

export interface ICollaboratorUser {
  user_name: string;
  profile_pic: string;
  sk: string;
  last_name: string;
  permission: boolean;
  pk: string;
  gsi4pk: string;
  first_name: string;
  email: string;
}

export const TAB_ARRAY = ['image', 'video', 'article', 'welcome_video']